// extracted by mini-css-extract-plugin
export default {"btn":"button-icon-custom_btn__0z+S2","outline-only":"button-icon-custom_outline-only__GGtAS"};